const NS = 'WoolLabRenameMoodboardModalBlock';
const CLS = 'woolLabRenameMoodboardModalBlock';

export class WoolLabRenameMoodboardModalBlock {
	constructor(el) {
		this.$el = $(el);

		this.newName = '';

		this.$btnDone = this.$el.find(`.${CLS}-doneBtn`);
		this.$updateBtn = this.$el.find(`.${CLS}-updateBtn`);
		this.$input = this.$el.find(`.${CLS}-shareSwatch-textInput`);
		this.getMyMoodboardsApi = $('.woolLabInteractiveMoodboardBlock').data('getMyMoodboardsApi');
		this.$inputContainer = this.$el.find(`.${CLS}-shareSwatch-textInput-container`);

		this.arrMyMoodboardsNames = this.getMyMoodboards();

		this.$input.on('keyup', (event) => {
			$('#dulicateWarningText').remove();
			let input = $(event.currentTarget).val().trim().toLowerCase();
			if (input.length > 0) {
				if(this.arrMyMoodboardsNames.includes(input)){
					$(this.$inputContainer).append("<p id='dulicateWarningText' style='color:#FF0000'>This moodboard name already exists.</p>");
					this.$updateBtn.addClass('disabled');
				}
				else{
				$('#dulicateWarningText').remove();
				this.$updateBtn.removeClass('disabled');
				}
			} else {
				this.$updateBtn.addClass('disabled');
			}

			this.newName = input;
		});
	}

	getMyMoodboards(){
		let names=[];
		let url = this.getMyMoodboardsApi;
		var data=$.parseJSON($.ajax({
            url: url,
            type:'get',
            dataType:'json',
			async: false
        }).responseText);


		$.each( data, function( i, val ) {
			names.push(val.name.toLowerCase());
		});
		
		return names;
	}
}

